import { TCBReceiptApi } from "@/network/pb/proto";

export const DefaultPath = "/announcement/list"; /* 預設網址 */

//------------------------------------------------------------------
// 定義權限管理對應之常數
//------------------------------------------------------------------
export enum PermissionCode { // 依後端最新wf為主
    /* 特約商店資料管理 */
    Store = "1",
    StoreData = "1", // 特約商店資料
    StoreReconciliation = "1", // 特約商店對帳查詢 // 未來權限規劃 -> 2 // 待保留 // 目前是舊版 其權限與對帳相同 尚未獨立分出來
    StoreReconciliationSingle = "1", // 單一特約商店對帳查詢 // 未來權限規劃 -> 3 // 待保留 // 目前是舊版 其權限與對帳相同 尚未獨立分出來
    StoreReconciliationReport = "4", // 報表下載專區

    /* Web對帳特約商店帳號與權限資料管理 */
    StoreAccount = "2",
    StoreAccountMethod = "1", // 特約商店帳號管理

    /* 電子發票特約商店帳號管理 */
    EReceiptAccount = "3",
    EReceiptAccountUser = "1", // 電子發票帳號管理

    /* 批次作業與排程管理 */
    Schedule = "4",
    ScheduleMethod = "1", // 批次作業排程管理
    ScheduleRecord = "1", // 批次作業排程執行紀錄 // 未來權限規劃 -> 2 // 待保留 // 目前是舊版 其權限與"批次作業排程管理"相同 尚未獨立分出來
    ScheduleDownload = "1", // 營業日設定 // 未來權限規劃 -> 3 // 待保留 // 目前是舊版 其權限與"批次作業排程管理"相同 尚未獨立分出來
    ScheduleBusinessDaySetting = "1", // 批次檔案下載 // 未來權限規劃 -> 4 // 待保留 // 目前是舊版 其權限與"批次作業排程管理"相同 尚未獨立分出來

    /* 系統功能權限群組管理 */
    GroupPermission = "7",
    GroupPermissionSystem = "1", // 系統功能群組權限
    GroupPermissionStore = "2", // 前端Web收單特店對帳群組權限

    /* 活動日誌管理 */
    Log = "8",
    LogSystem = "1", // 系統使用者活動紀錄
    LogStore = "2", // 前端Web收單特店使用者活動紀錄

    /* 公告管理 */
    Announcement = "9",
    AnnouncementMethod = "1", // 公告管理

    //------------------------------------------------------------------

    /* 前端Web收單特店對帳查詢系統使用者帳號管理 */ 
    BankStore = "1",
    BankStoreUser = "1", // 特約商店資料
    /* 前端Web收單特店對帳查詢系統使用者帳號管理 */

    /* 對帳交易查詢 */
    BankReconciliation = "2",
    BankReconciliationReimbursement = "1", // 請款明細
    BankReconciliationAppropriation = "2", // 撥款明細
    BankReconciliationDeposit = "3", // 存摺入帳明細
    BankReconciliationReport = "4", // 報表下載專區
    /* 對帳交易查詢 */
}
//------------------------------------------------------------------


const GroupPermissionStoreNameMap :
{
    [key: string]: {
        name: string,
        methodName: { [key: string]: string }
    }
} = {
    "1": {
        name: "前端Web收單特店對帳查詢系統使用者帳號管理",
        methodName: {
            "1": "特約商店資料",
        },
    },
    "2": {
        name: "對帳交易查詢",
        methodName: {
            "1": "請款資料",
            "2": "撥款明細",
            "3": "存摺入帳明細",
            "4": "報表下載專區",
        },
    },
};

const GroupPermissionStoreMap: { [key: string]: TCBReceiptApi.Protobuf.IGroupMap } = {
    "1": { // 前端Web收單特店對帳查詢系統使用者帳號管理
        "map" : {
            "1": { // 特約商店資料
                get: 0,
                add: 0,
                edit: 0,
                delete: 0,
                release: 0,
            },
        }
    },
    "2": { // 對帳交易查詢
        "map" : {
            "1": { // 請款資料
                get: 0,
                add: 0,
                edit: 0,
                delete: 0,
                release: 0,
            },
            "2": { // 撥款明細
                get: 0,
                add: 0,
                edit: 0,
                delete: 0,
                release: 0,
            },
            "3": { // 存摺入帳明細
                get: 0,
                add: 0,
                edit: 0,
                delete: 0,
                release: 0,
            },
            "4": { // 報表下載專區
                get: 0,
                add: 0,
                edit: 0,
                delete: 0,
                release: 0,
            },
        }
    },
};

export const GroupPermission = {
    // store
    GroupPermissionStoreNameMap,
    GroupPermissionStoreMap,
};